import request from "./../utils/request";
import { i18n } from "../language";

const currentLocale = () => (i18n && i18n.locale) || "tr";

export const TABLE_TEMPLATE_API = {
    list: ({ groupBy, locale } = {}) => {
        return request({
            url: "/tables/templates",
            method: "get",
            params: {
                groupBy,
                locale: locale || currentLocale(),
            },
        }).then((response) => response.data);
    },

    getByKey: (key, { locale } = {}) => {
        return request({
            url: `/tables/templates/${key}`,
            method: "get",
            params: { locale: locale || currentLocale() },
        }).then((response) => response.data);
    },

    apply: (key, { selectedTableKeys, withDemoData, locale, fieldOverrides } = {}) => {
        return request
            .post(`/tables/templates/${key}/apply`, {
                selectedTableKeys,
                withDemoData,
                locale: locale || currentLocale(),
                fieldOverrides,
            })
            .then((response) => response.data);
    },
};
